<h1>Glitch Art #genuary3</h1>

<p>
  My laptop is too buggy to succeed. Please advise.
  <video id="vid" controls autoplay loop muted>
    <source src="../genuary/img/03/final.mp4" type="video/mp4" />
    This browser does not display the video tag.
  </video>
</p>

<style>
  #vid {
    width: 100%;
    height: auto;
  }
</style>
